import axios from 'axios'


const DataAssistantGetAPI = (data) => axios.get(`${process.env.REACT_APP_AI_HOST}/api/ai/chat?${new URLSearchParams(data).toString()}`)

const DataSearchAPI = (data) => axios.post(`${process.env.REACT_APP_AI_HOST}/api/ai/search`, data)

export default { DataAssistantGetAPI, DataSearchAPI }
